export default function getCouponReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GETS_COUPON_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GETS_COUPON_ERROR':
            return {...state, ...{error: action.error}};

        case 'GETS_COUPON_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}